// The sample rate for Sentry traces, set to 20% for performance monitoring
export const SENTRY_TRACE_SAMPLE_RATE = 0.2

// The sample rate for Mixpanel traces, set to 100% for detailed tracking
export const MIXPANEL_TRACE_SAMPLE_RATE = 1
